import { makeStyles } from "@mui/styles";
import { Button, Tooltip } from "@mui/material";
import React from "react";

export const CustomButton = (props) => {

    const { name, type, action, title } = props;
    const styles = useStyles();

    return (
        <Tooltip title={ title }>
            <Button
                type={ type }
                variant="outlined"
                size="small"
                className={styles.successBtn}
                onClick={ action }
            >
                { name }
            </Button>
        </Tooltip>
    )
};

CustomButton.defaultProps = {
    name: '',
    type: 'button',
    action: () => false,
    title: ''
}

const useStyles = makeStyles({
    successBtn: {
        background: '#00365F !important',
        color: '#fff !important',
        fontWeight: 'bold !important',
        '&:hover': {
            color: '#00365F !important',
            background: '#fff !important',
            borderColor: '#00365F !important'
        }
    }
});